import React from "react";
import classes from "./PaymentPreview.module.css";
import arrow from "../../../Assets/icons/SVG/arrow.svg";
import { connect } from "react-redux";
import Loader from "react-loader-advanced";
import SweetAlert from "../../../component/commonComponents/SweetAlert";
import NewSweetAlert from "react-bootstrap-sweetalert";
import Cookies from "universal-cookie";
import loading from "../../../Assets/Images/loader-green.gif";
import * as actionTypes from "../../../Action/Index";
import { withRouter } from "react-router-dom";
import { Col, Row, Form, Button, Card } from "react-bootstrap";
// const Cryptr = require("cryptr");

class PaymentReview extends React.Component {
  state = {
    encRequest: "",
    accessCode: "",
    error: false,
    userType: localStorage.getItem("userType"),
  };

  // cryptr = new Cryptr("foxmatrix#brijesh@atishay$nikhil");
  componentWillReceiveProps(nextProps) {
    if (
      this.state.encRequest !== nextProps.encRequest &&
      this.state.accessCode !== nextProps.accessCode
    ) {
      let date = this.props.invoiceData.dateTime.split(" - ");

      // let encryptedString = this.cryptr.encrypt(nextProps.orderId);
      let encryptedString = nextProps.orderId;

      new Cookies().set("CNorderId", encryptedString);
      new Cookies().set("CNjobId", nextProps.selectedJobProfileId.id);
      new Cookies().set("CNmodeofinterview", nextProps.selectedMode);
      new Cookies().set("CNendTime", date[1]);
      new Cookies().set("CNinterviewDate", date[0]);
      new Cookies().set(
        "CNamount",
        (nextProps.invoiceData.amount * 0.18).toFixed(2) -
          nextProps.creditBalance -
          parseInt(nextProps.invoiceData.amount * -1)
      );
      //new Cookies().set('jobId', this.props.selectedJobProfileId.id);
      //console.log(new Cookies().getAll())
      this.setState(
        {
          encRequest: nextProps.encRequest,
          accessCode: nextProps.accessCode,
        },
        () => document.getElementById("paymentForm").submit()
      );
    }

    // if (this.state.orderHistoryData != nextProps.OrderHistoryData) {
    //     this.setState({
    //         orderHistoryData: nextProps.OrderHistoryData,
    //     })
    // }
  }

  makePayment = () => {
    if (
      (this.props.invoiceData.amount * 0.18).toFixed(2) -
        this.props.creditBalance -
        parseInt(this.props.invoiceData.amount * -1) <=
      0
    ) {
      let date = this.props.invoiceData.dateTime.split(" - ");
      new Cookies().set("CNorderId", "");
      new Cookies().set("CNjobId", this.props.selectedJobProfileId.id);
      new Cookies().set("CNmodeofinterview", this.props.selectedMode);
      new Cookies().set("CNendTime", date[1]);
      new Cookies().set("CNinterviewDate", date[0]);
      new Cookies().set(
        "CNamount",
        (this.props.invoiceData.amount * 0.18).toFixed(2) -
          this.props.creditBalance -
          parseInt(this.props.invoiceData.amount * -1)
      );

      //console.log(new Cookies().getAll())

      // let datesend = `${new Cookies().get('interviewDate').split(' ').join('-')}-2020`
      // const bodyFormData = {
      //     "amount": `${new Cookies().get('amount') < 0 ? 0 : new Cookies().get('amount')}`,
      //     "candidateNotes": '',
      //     "endTime":  new Cookies().get('endTime'),
      //     "interviewDate": datesend,
      //     "interviewerId": new Cookies().get('interviewerId'),
      //     "interviewerNotes": '',
      //     "orderId": new Cookies().get('orderId'),
      //     "jobProfileId": new Cookies().get('jobId'),
      //     "startTime": new Cookies().get('endTime'),
      //     "modeofinterview":new Cookies().get('modeofinterview')
      // }
      // this.props.scheduleInterview(bodyFormData);
      this.props.history.push("/status");
    } else {
      this.props.makeSecurityDepositPayment(
        (this.props.invoiceData.amount * 0.18).toFixed(2) -
          this.props.creditBalance -
          parseInt(this.props.invoiceData.amount * -1)
      );
    }
  };

  componentDidMount() {
    this.props.getCreditBalance();
  }

  render() {
    //console.log(this.props.selectedJobProfileId, this.props.creditBalance)
    let date = this.props.invoiceData.dateTime.split(" - ");
    console.log(date);
    return (
      <Loader
        show={this.props.loader || this.props.creditBalance === null}
        message={<img src={loading} />}
        style={{ height: "400px" }}
        foregroundStyle={{ color: "#fbb03b" }}
        backgroundStyle={{ backgroundColor: "#f3efef" }}
      >
        {this.props.loader ? null : this.props.creditBalance ===
          null ? null : this.props.creditBalance === "fail" ? (
          <SweetAlert
            type="danger"
            show="true"
            msg={"Something went wrong"}
            handleOk={() => this.props.history.push("/interview")}
          />
        ) : (
          <div className={classes.parentContainer}>
            {/* <div className={classes.heading}>
                    <img src={arrow} width={40} height={25} onClick={this.props.gotoSelectInterviewer} style={{cursor: 'pointer'}}></img>
                    <h3>Review and Make Payment</h3>
                </div> */}
            {this.state.userType !== "0" && (
              <div className={classes.detailContainer}>
                <div className={classes.details}>
                  <p>Interview Details</p>
                  <div className={classes.detailsList}>
                    <div className={classes.detailsRow}>
                      <p className={classes.detailsListLeft}>
                        Interviewer Position Title:
                      </p>
                      <p className={classes.detailsListRight}>
                        {this.props.invoiceData.position}
                      </p>
                    </div>
                    <div className={classes.detailsRow}>
                      <p className={classes.detailsListLeft}>
                        Interviewer Experience:
                      </p>
                      <p
                        className={classes.detailsListRight}
                      >{`${this.props.invoiceData.years} years ${this.props.invoiceData.months} months`}</p>
                    </div>
                    <div className={classes.detailsRow}>
                      <p className={classes.detailsListLeft}>Interview Date:</p>
                      <p className={classes.detailsListRight}>{date[0]}</p>
                    </div>
                    <div className={classes.detailsRow}>
                      <p className={classes.detailsListLeft}>Interview Time:</p>
                      <p className={classes.detailsListRight}>{date[1]}</p>
                    </div>
                    {/* <div className={classes.detailsListLeft}>
                               
                                
                                
                                
                            </div>
                            <div className={classes.detailsListRight}>
                                
                                
                                
                                
                            </div> */}
                  </div>
                </div>

                <div className={classes.price}>
                  <p>Interview Price</p>
                  <div className={classes.priceDetails}>
                    <div className={classes.priceDetailsLeft}>
                      <p>Interview Price:</p>
                      <p>GST(%):</p>
                      <p>Credits:</p>
                    </div>
                    <div className={classes.priceDetailsRight}>
                      <p>&#8377; {this.props.invoiceData.amount}.00</p>
                      <p>
                        &#8377;&nbsp;
                        {(this.props.invoiceData.amount * 0.18).toFixed(2)}
                      </p>
                      <p>&#8377; {this.props.creditBalance}.00</p>
                    </div>
                  </div>
                </div>

                {this.state.error ? (
                  <NewSweetAlert
                    style={{ width: "400px", marginLeft: "-210px" }}
                    warning
                    onConfirm={this.hideAlert}
                    confirmBtnBsStyle="none"
                    confirmBtnCssClass={classes.confirmButtonStyle}
                  >
                    {"Invalid amount"}
                  </NewSweetAlert>
                ) : null}
                {this.props.securityDepositErr ? (
                  <SweetAlert
                    type="danger"
                    show="true"
                    msg={this.props.securityDepositErrMsg}
                  />
                ) : null}

                <div className={classes.totalPrice}>
                  <div style={{ width: "65%" }}>
                    <p>Total Price:</p>
                  </div>
                  <div style={{ width: "35%" }}>
                    <p>
                      &#8377;&nbsp;
                      {(this.props.invoiceData.amount * 0.18).toFixed(2) -
                        this.props.creditBalance -
                        parseInt(this.props.invoiceData.amount * -1) <=
                      0
                        ? 0
                        : (this.props.invoiceData.amount * 0.18).toFixed(2) -
                          this.props.creditBalance -
                          parseInt(this.props.invoiceData.amount * -1)}
                    </p>
                  </div>
                </div>
                {/* <div>
                        <Button type="button" onClick={this.makePayment} variant="warning" className={classes.paymentButton}> Confirm Payment </Button>
                    </div> */}

                <div
                  className={classes.paymentButton}
                  onClick={this.makePayment}
                >
                  <span style={{ fontWeight: 600 }}>Confirm Payment</span>
                </div>
              </div>
            )}
            <Row>
              <Col md={1}></Col>
              <Col md={2}>
                <Button
                  type="button"
                  onClick={this.props.gotoSelectInterviewer}
                  variant="warning"
                  className={classes.nextBtn}
                >
                  {" "}
                  Previous{" "}
                </Button>
              </Col>
            </Row>
          </div>
        )}
        <form
          id="paymentForm"
          method="post"
          action="https://secure.ccavenue.com/transaction.do?command=initiateTransaction"
          target="_self"
        >
          <input
            type="hidden"
            id="encRequest"
            name="encRequest"
            value={this.state.encRequest}
          />
          <input
            type="hidden"
            name="access_code"
            id="access_code"
            value={this.state.accessCode}
          />
          <input hidden type="submit" />
        </form>
      </Loader>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state.employeeReducer.encRequest);
  return {
    creditBalance: state.employeeReducer.creditBalance,

    encRequest: state.employeeReducer.encRequest,
    accessCode: state.employeeReducer.access_code,
    orderId: state.employeeReducer.orderId,
    loader: state.employeeReducer.loader,

    securityDepositErr: state.employeeReducer.securityDepositErr,
    securityDepositErrMsg: state.employeeReducer.securityDepositErrMsg,
    securityDepositServerErr: state.employeeReducer.securityDepositServerErr,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    makeSecurityDepositPayment: (amount) =>
      dispatch(actionTypes.makeSecurityDepositPayment(amount)),
    getCreditBalance: () => dispatch(actionTypes.getCreditBalance()),
    //scheduleInterview: (orderId) => dispatch(actionTypes.scheduleInterview(orderId))
    // getOrderHistory: (page, limit) => dispatch(actionTypes.getOrderHistory(page, limit)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PaymentReview)
);
